export const environment = {
  production: false,
  api: 'https://dev-api.suburbansupplyinc.com',
  cognitoClientId: 'c3keo7vskb5h0i2h8rlt3embi',
  authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_ONqknTZBw',
  cognitoDomain: 'https://us-east-1onqkntzbw.auth.us-east-1.amazoncognito.com',
  appTitle: 'Dev Rep Suburban',
  rum: {
    enabled: false,
    appName: 'rep-flow',
    environmentName: 'dev',
    applicationId: '',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-east-2',
    identityPoolId: '',
    guestRoleArn: '',
    sessionSampleRate: 1,
    allowCookies: true,
    enableXRay: false,
  },
};
